'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];
    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }
  return target;
};
var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }
  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();
var _react = require('react');
var _react2 = _interopRequireDefault(_react);
var _propTypes = require('prop-types');
var _propTypes2 = _interopRequireDefault(_propTypes);
var _HeaderCell = require('./HeaderCell');
var _HeaderCell2 = _interopRequireDefault(_HeaderCell);
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    'default': obj
  };
}
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var TableHeader = function (_Component) {
  _inherits(TableHeader, _Component);
  function TableHeader(props) {
    _classCallCheck(this, TableHeader);
    var _this = _possibleConstructorReturn(this, (TableHeader.__proto__ || Object.getPrototypeOf(TableHeader)).call(this, props));
    _this.state = {
      openFilter: null
    };
    _this.handleFilterClick = _this.handleFilterClick.bind(_this);
    return _this;
  }
  _createClass(TableHeader, [{
    key: 'render',
    value: function () {
      function render() {
        var _this2 = this;
        var _props = this.props,
          columns = _props.columns,
          isTableGrouped = _props.isTableGrouped;
        if (isTableGrouped) {
          return _react2['default'].createElement('thead', null, _react2['default'].createElement('tr', {
            className: 'headerTopRow'
          }, this.renderParentHeaderCells(columns)), _react2['default'].createElement('tr', {
            className: 'headerBottomRow'
          }, this.renderChildHeaderCells(columns)));
        }
        return _react2['default'].createElement('thead', null, _react2['default'].createElement('tr', null, columns.map(function (col) {
          return _this2.renderHeaderCell(col);
        })));
      }
      return render;
    }()
  }, {
    key: 'renderParentHeaderCells',
    value: function () {
      function renderParentHeaderCells(columns) {
        var _this3 = this;
        return columns.reduce(function (parentCells, column) {
          if (!column.isChild) {
            var childCount = column.childCount;
            var rowSpan = childCount > 0 ? 1 : 2;
            var colSpan = childCount > 0 ? childCount : 1;
            var options = {
              colSpan: colSpan,
              isParent: childCount > 0,
              rowSpan: rowSpan
            };
            var parentHeaderCell = _this3.renderHeaderCell(column, options);
            parentCells.push(parentHeaderCell);
          }
          return parentCells;
        }, []);
      }
      return renderParentHeaderCells;
    }()
  }, {
    key: 'renderChildHeaderCells',
    value: function () {
      function renderChildHeaderCells(columns) {
        var _this4 = this;
        return columns.reduce(function (childCells, column) {
          if (column.isChild) {
            var className = null;
            if (column.lastChild) {
              className = 'headerGroup-lastChild';
            }
            var childHeaderCell = _this4.renderHeaderCell(column, {
              className: className
            });
            childCells.push(childHeaderCell);
          }
          return childCells;
        }, []);
      }
      return renderChildHeaderCells;
    }()
  }, {
    key: 'renderHeaderCell',
    value: function () {
      function renderHeaderCell(columnConfig) {
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var openFilter = this.state.openFilter;
        var _props2 = this.props,
          filterable = _props2.filterable,
          filters = _props2.filters,
          filterSelectionHandler = _props2.filterSelectionHandler,
          filterValues = _props2.filterValues,
          sortClickHandler = _props2.sortClickHandler,
          sortColumn = _props2.sortColumn,
          sortDirection = _props2.sortDirection;
        var name = columnConfig.name,
          value = columnConfig.value,
          sorting = columnConfig.sorting;
        var className = options.className,
          colSpan = options.colSpan,
          isParent = options.isParent,
          rowSpan = options.rowSpan;
        var isColumnSortable = sorting;
        var isColumnFilterable = filterable;
        var isFiltered = false;
        var isSorted = sortColumn === columnConfig.value;
        if (isParent) {
          isColumnSortable = false;
          isColumnFilterable = false;
        }
        if (isColumnFilterable) {
          isFiltered = filters[columnConfig.value] && filters[columnConfig.value].length > 0;
        }
        var headerCellProps = {
          className: className,
          columnValue: value,
          colSpan: colSpan,
          isFiltered: isFiltered,
          isFilterOpen: openFilter === value,
          filterable: isColumnFilterable,
          filters: filters,
          filterClickHandler: this.handleFilterClick,
          filterSelectionHandler: filterSelectionHandler,
          filterItems: filterValues && filterValues[value],
          isSorted: isSorted,
          rowSpan: rowSpan,
          sorting: isColumnSortable,
          sortClickHandler: sortClickHandler,
          sortDirection: sortDirection
        };
        return _react2['default'].createElement(_HeaderCell2['default'], _extends({
          key: value
        }, headerCellProps), name);
      }
      return renderHeaderCell;
    }()
  }, {
    key: 'handleFilterClick',
    value: function () {
      function handleFilterClick(columnValue, shouldCloseFilter) {
        var openFilter = this.state.openFilter;
        if (shouldCloseFilter) {
          this.setState({
            openFilter: false
          });
        } else {
          this.setState({
            openFilter: openFilter === columnValue ? null : columnValue
          });
        }
      }
      return handleFilterClick;
    }()
  }]);
  return TableHeader;
}(_react.Component);
TableHeader.propTypes = {
  columns: _propTypes2['default'].arrayOf(_propTypes2['default'].shape({
    value: _propTypes2['default'].string.isRequired,
    name: _propTypes2['default'].oneOfType([_propTypes2['default'].string, _propTypes2['default'].element]).isRequired,
    sorting: _propTypes2['default'].bool,
    sorter: _propTypes2['default'].func,
    customFilters: _propTypes2['default'].array,
    columns: _propTypes2['default'].array,
    isChild: _propTypes2['default'].bool,
    lastChild: _propTypes2['default'].bool,
    childCount: _propTypes2['default'].number
  })),
  filterable: _propTypes2['default'].bool,
  filters: _propTypes2['default'].object,
  filterSelectionHandler: _propTypes2['default'].func,
  filterValues: _propTypes2['default'].object,
  isTableGrouped: _propTypes2['default'].bool,
  sortClickHandler: _propTypes2['default'].func,
  sortColumn: _propTypes2['default'].string,
  sortDirection: _propTypes2['default'].oneOf(['ASCEND', 'DESCEND'])
};
TableHeader.displayName = 'DataTable-TableHeader';
exports['default'] = TableHeader;